export enum ProvidersQueryKeys {
  Providers = "providers",
}
